/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PieChartIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="donut-chart-icon">
      <path d="M13.5,10.5 L23.5,10.5 C23.5,4.978 19.023,0.5 13.5,0.5 L13.5,10.5 Z" />
      <path d="M20.571,19.571 C22.381,17.761 23.5,15.261 23.5,12.5 L13.5,12.5 L20.571,19.571 Z" />
      <path d="M10.5,3.5 C4.978,3.5 0.5,7.978 0.5,13.5 C0.5,22.438 11.33,26.812 17.571,20.571 L10.5,13.5 L10.5,3.5 Z" />
    </g>
  </svg>
);

export default PieChartIcon;
